import { useMemo, useEffect } from "react";

import useTimeoutFn from "react-use/lib/useTimeoutFn";

function useTimeoutFunction(fn: () => void = () => null, ms = 0) {
  const [, cancelTimeout, resetTimeout] = useTimeoutFn(fn, ms);

  const disabled = useMemo(() => !(typeof ms === "number" && ms > 0), []);

  useEffect(() => {
    if (disabled) {
      cancelTimeout();
    } else {
      resetTimeout();
    }

    return () => {
      cancelTimeout();
    };
  }, [disabled]);
}

export { useTimeoutFunction };
